var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.isDisabled ? 'div' : 'router-link',{tag:"component",staticClass:"logo-link",attrs:{"to":"/","exact-active-class":"active"}},[_c('LogoIcon',{staticClass:"logo"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }